import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const NavigationRight4 = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.93097 15.5L14.0774 8.35355L14.431 8L14.0774 7.64645L6.93103 0.5H7.40245L14.7845 7.88206L14.7845 7.88209L14.9024 7.99998L14.7845 8.11785L7.40238 15.5H6.93097ZM2.2643 15.5L9.41078 8.35355L9.76433 8L9.41078 7.64645L2.26436 0.5H2.73576L10.1178 7.88206L10.1179 7.88209L10.2357 7.99998L10.1179 8.11785L2.7357 15.5H2.2643Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>,
  'NavigationRight4'
);
